export default "__VITE_ASSET__97496302__"